import {
  Box,
  BoxProps,
  Button,
  HStack,
  Icon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
} from "@chakra-ui/react"
import DetailedRatingProgressBar from "@components/Product/DetailedRatingProgressBar"
import { starIcons } from "@components/Product/Ratings"
import { AggregateRatingData } from "@type/product"
import { useState } from "react"
import { FaInfoCircle } from "react-icons/fa"

const DetailedRatings = ({
  aggregateRating,
  ...props
}: BoxProps & { aggregateRating: AggregateRatingData }) => {
  const stars = aggregateRating.ratingValue.toFixed(1)
  const count = aggregateRating.ratingCount
  const [showRatings, setShowRatings] = useState<boolean>(false)
  return (
    <Box {...props}>
      <Popover
        onOpen={() => setShowRatings(true)}
        onClose={() => setShowRatings(false)}
      >
        <PopoverTrigger>
          <Button
            variant={"ghost"}
            p={0}
            fontWeight={400}
            _hover={{
              bg: "transparent",
            }}
          >
            <HStack
              alignItems={"center"}
              spacing={1}
            >
              <Box
                fontSize={"sm"}
                fontWeight={500}
                mt={0.5}
              >
                {stars}
              </Box>
              <HStack spacing={0}>{starIcons(Number(stars))}</HStack>
              <Box fontSize={"xs"}>{`(${
                Intl.NumberFormat("en-AE", {
                  notation: "compact",
                  maximumFractionDigits: 0,
                  useGrouping: true,
                  compactDisplay: "long",
                }).format(count) + `${count > 999 ? "+" : ""}`
              })`}</Box>
              <Icon
                as={FaInfoCircle}
                width={3}
                height={3}
              />
            </HStack>
          </Button>
        </PopoverTrigger>
        <PopoverContent fontWeight={400}>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader
            fontSize={"sm"}
            fontWeight={500}
          >
            {`${
              Intl.NumberFormat("en-AE", {
                notation: "compact",
                maximumFractionDigits: 0,
                useGrouping: true,
                compactDisplay: "long",
              }).format(count) + `${count > 999 ? "+" : ""}`
            } rating${count > 1 ? "s" : ""}`}
          </PopoverHeader>
          <PopoverBody fontSize={"sm"}>
            {aggregateRating.identifier
              .slice()
              .reverse()
              .map((source, index) => {
                return (
                  <HStack
                    key={index}
                    spacing={4}
                    alignItems={"center"}
                    p={1}
                  >
                    <HStack spacing={0}>{starIcons(5 - index)}</HStack>
                    <DetailedRatingProgressBar
                      rating={source.value}
                      count={count}
                      isCounting={showRatings}
                    />
                    <Box
                      as={"span"}
                      minW={12}
                    >
                      {Intl.NumberFormat("en-AE", {
                        notation: "compact",
                        maximumFractionDigits: 0,
                        useGrouping: true,
                        compactDisplay: "short",
                      }).format(source.value) +
                        `${source.value > 999 ? "+" : ""}`}
                    </Box>
                  </HStack>
                )
              })}
          </PopoverBody>
          <PopoverFooter fontSize={"xs"}>
            <HStack spacing={1}>
              <Icon
                as={FaInfoCircle}
                width={3}
                height={3}
              />
              <Box as={"span"}>{"We collect ratings from various sources"}</Box>
            </HStack>
          </PopoverFooter>
        </PopoverContent>
      </Popover>
    </Box>
  )
}

export default DetailedRatings
